import { Navigate } from 'react-router-dom'
import { useProjectId } from '../../../hooks/useProjectId'
import { MarketAudienceEditor } from '../MultiMarket/AudiencesPage'
import { MarketTabsLayout } from '../MultiMarket/MarketTabsLayout'
import { surveysByCreation } from '../MultiMarket/markets.utils'
import { WaveFlowBreadcrumb } from './WaveFlowBreadcrumb'
import { useWaveId } from './useWaveId'
import { useWaves } from './useWaves'

/**
 * The multi-market market-tabs shell over this wave's own markets. A market
 * added here is attached to the wave, so it appears on no other.
 */
export const WaveAudiencesPage = () => {
  const projectId = useProjectId()
  const waveId = useWaveId()
  const { waves, loading } = useWaves(projectId)
  const wave = waves.find((candidate) => candidate.waveId === waveId)

  if (loading) {
    return null
  }

  if (!wave) {
    return <Navigate to={`/project/${projectId}`} replace />
  }

  return (
    <MarketTabsLayout
      breadcrumb={<WaveFlowBreadcrumb activeStep="Audiences" />}
      title="Audiences"
      marketBasePath={`/project/${projectId}/wave/${waveId}/audiences`}
      markets={surveysByCreation(wave.surveys)}
      waveId={waveId}
      emptyText="Add a market to configure its audience."
      renderEditor={() => <MarketAudienceEditor />}
    />
  )
}
